import React from "react";

function LoadingApp() {
    return (
    <div id="loader" className="d-flex align-items-center justify-content-center w-100 min-vh-100 background-white">
        <img className="w-2/5 h-auto" src="/icon.gif"/>
    </div>
    );
}

export default LoadingApp;
